var _circle, _line, _line2, _line3, _line4, _circle2, _line5, _line6, _line7, _line8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTttLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 484,
    height: 484,
    viewBox: "0 0 484 484",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 242,
    r: 242,
    fill: "#2BF3C4"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 178.685,
    y1: 70.4751,
    x2: 178.685,
    y2: 414.809,
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 312.511,
    y1: 70.4751,
    x2: 312.511,
    y2: 414.809,
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 69.1909,
    y1: 171.49,
    x2: 413.525,
    y2: 171.49,
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 69.191,
    y1: 305.315,
    x2: 413.525,
    y2: 305.315,
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 248.419,
    cy: 236.865,
    r: 41.8594,
    stroke: "black",
    strokeWidth: 10
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 339.58,
    y1: 210.546,
    x2: 396.7,
    y2: 267.666,
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 340.212,
    y1: 267.666,
    x2: 397.332,
    y2: 210.546,
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 218.901,
    y1: 83.4482,
    x2: 276.021,
    y2: 140.568,
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 219.533,
    y1: 140.568,
    x2: 276.653,
    y2: 83.4482,
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTttLogo);
export default __webpack_public_path__ + "static/media/ttt_logo.6813ec57c628579fe9c1c74a222f9d5a.svg";
export { ForwardRef as ReactComponent };